var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedinBoxFill = function SvgLinkedinBoxFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.702 17.704h-2.399v-3.76c0-.896-.018-2.05-1.251-2.05-1.25 0-1.44.976-1.44 1.985v3.824h-2.4v-7.73h2.304v1.053h.031c.322-.606 1.105-1.248 2.275-1.248 2.43 0 2.88 1.6 2.88 3.682zm-10.2-8.788a1.391 1.391 0 0 1-1.157-2.168 1.393 1.393 0 1 1 1.157 2.168m1.203 8.787H6.3v-7.73h2.407v7.73M18.903 3.898H5.096A1.18 1.18 0 0 0 3.9 5.066V18.93c0 .645.535 1.167 1.195 1.167H18.9c.661 0 1.201-.522 1.201-1.167V5.066c0-.646-.54-1.168-1.2-1.168z"
  })));
};
export default SvgLinkedinBoxFill;